import { IMobilePhone } from "./mobile-phone.model";

export interface ICardHolder {
  email?: string;
  billAddrState?: string;
  cardholderName?: string;
  billAddrCity?: string;
  billAddrCountry?: string;
  billAddrLine1?: string;
  billAddrLine2?: string;
  billAddrLine3?: string;
  billAddrPostCode?: string;
  mobilePhone?: IMobilePhone;
}

export class CardHolder implements ICardHolder {
  constructor(
    email?: string,
    cardHolderName?: string,
    billAddrCity?: string,
    billAddrCountry?: string,
    billAddrLine1?: string,
    billAddrLine2?: string,
    billAddrLine3?: string,
    billAddrPostCode?: string,
    mobilePhone?: IMobilePhone
  ) { }
}